<script setup lang="ts">
import { onMounted } from 'vue';
import { RouterView } from 'vue-router';
import { useLocalizationStore } from '@/stores/localization';
import { useClientStore } from '@/stores/client';
import LoadingSpinner from '@/components/LoadingSpinner.vue';

const localizationStore = useLocalizationStore();
const clientStore = useClientStore();

onMounted(async () => {
  // Initialize client configuration based on hostname
  clientStore.initializeClient();
  
  // Load default locale
  await localizationStore.loadLocale('en');
});
</script>

<template>
  <div id="classify" :class="`ccce-client-${clientStore.clientId}`">
    <Suspense>
      <template #default>
        <RouterView />
      </template>
      <template #fallback>
        <LoadingSpinner />
      </template>
    </Suspense>
  </div>
</template>

<style lang="less">
#classify {
  font-family: 'Lato', sans-serif;
  min-height: 100vh;
}
</style>

